<template>
    <ds-table
        :data="data.permissions"
        :heads="heads"
        :paginate="false"
        spacer
        :max-items="data.permissions.length"
    >
        <template v-slot:role="{role}">
            <vs-chip v-tooltip.position.left="role.rolesList.join('<br>')">
                <vs-avatar color="#f0f0f0" text-color="#175ea5" v-bind="$iconData('icon-git-merge', 'fi-rs-code-merge')"></vs-avatar>
                <span>{{ role.rolesLength }}</span>
            </vs-chip>
        </template>

        <template v-slot:actions="{actions}">
            <vs-button  v-can="'permission.update'"  @click.stop="editPermission(actions)" v-tooltip="i('modals.Edit_permission')" radius color="primary" type="flat" v-bind="$iconData('icon-edit-2', 'fi-rr-file-edit')"></vs-button>
            <vs-button  v-can:show="'permission.update'" disabled radius color="primary" type="flat" v-bind="$iconData('icon-edit-2', 'fi-rr-file-edit')"></vs-button>
        </template>
    </ds-table>
</template>

<script>
import i18n from '@/i18n/i18n'
import EventBus from '@/store/eventBus'

export default {
    props: {
        data: {
            type: Object,
            require: true
        },
        roles: {
            type: Array,
            required: true
        },
    },

    data() {
        return {
            heads: [
                {name: 'global.Name', key: 'name', sortKey: 'name', value: 'name', display: true},
                {name: 'global.Description', key: 'description', sortKey: 'description', value: 'description', display: true},
                {name: 'global.Role', key: 'role', sortKey: 'rolesLength', value: 'role', display: true},
                {name: 'global.Slug', key: 'slug', sortKey: 'slug', value: 'slug', display: true},
                {name: 'global.Actions', key: 'actions', value: 'actions', display: true},
            ]
        }
    },

    methods: {
        i(val) {
            return i18n.tc(val)
        },

        editPermission(data) {
            EventBus.$emit('emitPopupEvent', {type: 'editPermissionModule', name: this.i('modals.Edit_permission'), ids: {data, rolesItems: this.roles, module: this.data}})
        }
    }
}
</script>
